import React from 'react';
import EmailCapture from './EmailCapture.js';

export default function Hero() {
  return (
    <section className="hero">
      <div className="shell hero-grid">
        <div className="hero-copy">
          <h1 className="hero-title">
            At-home gut health testing and <em>nutrition plans</em>.
          </h1>
          <p className="hero-body">
            Using one small sample, Floro maps the bacteria in your gut and turns it into food, fiber and supplement plans built for your biology.
          </p>
          <div className="hero-form">
            <EmailCapture variant="light" />
            <p className="mono-label email-fineprint">No spam. One email when your kit ships.</p>
          </div>
        </div>
        <div className="hero-visual">
          <img
            src="/assets/frontpage/banner.png"
            alt="Floro Gut Insights report, at-home test kit, and a person at rest"
          />
        </div>
      </div>
    </section>
  );
}
